import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import AuthProvider from "features/auth/AuthContext";
import { RouterProvider } from "react-router-dom";
import { router } from "router";
import { NuqsAdapter } from "nuqs/adapters/react";
import GoogleMapsProvider from "features/maps/GoogleMapsProvider";

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <NuqsAdapter>
      <Provider store={store}>
        <AuthProvider>
          <GoogleMapsProvider>
            <RouterProvider router={router} />
          </GoogleMapsProvider>
        </AuthProvider>
      </Provider>
    </NuqsAdapter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
